import { configureStore } from '@reduxjs/toolkit';
import editModeReducer from './features/editModeSlice';
import popoverSlice from './features/popoverSlice';
import progressSlice from './features/progressSlice';
import snackbarSlice from './features/snackbarSlice';
import logger from 'redux-logger';
import { createBrowserHistory } from 'history';
import toolbarSlice from './features/toolbarSlice';
import bottomBarSlice from './features/bottomBarSlice';
import notificationSlice from './features/notificationSlice';
import tabControlSlice from './features/tabControlSlice';
import gridSlice from './features/gridSlice';
import currentUserSlice from './features/currentUserSlice';
import configSlice from './features/configSlice';
import appbarSlice from './features/appbarSlice';
export const history = createBrowserHistory();

let middleware = [];

if (
  localStorage.getItem('logs') &&
  ![0, 2, 4, 6].includes(Number(localStorage.getItem('logs')))
) {
  middleware = [logger];
} else {
  middleware = [];
}

const store = configureStore({
  reducer: {
    edit: editModeReducer,
    popover: popoverSlice,
    // backdrop: progressSlice,
    // snackbar: snackbarSlice,
    // toolbar: toolbarSlice,
    // bottombar: bottomBarSlice,
    // grid: gridSlice,
    // tabController: tabControlSlice,
    appbar: appbarSlice,
    notification: notificationSlice,
    currentUser: currentUserSlice,
    config: configSlice
  },
  middleware: [...middleware],
});

export { store };
